import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Chip, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import api from '../../api/axios';
import { geographicAccessLabel, SalesAdminUser } from './types';

const TeamSection: React.FC = () => {
  const [team, setTeam] = useState<SalesAdminUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try { setTeam((await api.get('/sales-admin/users/team')).data); }
    catch (err: any) { setError(err?.response?.data?.message || 'Ekip bilgileri yüklenemedi.'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return <Stack spacing={2}>
    {error && <Alert severity="error">{error}</Alert>}
    <Box><Typography variant="h4" fontWeight={700}>Ekibim</Typography><Typography color="text.secondary">Coğrafi yetkiniz kapsamındaki aktif kullanıcılar.</Typography></Box>
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
      {loading ? <Box sx={{ p: 6, textAlign: 'center' }}><CircularProgress /></Box> : <Table><TableHead><TableRow><TableCell>Ad</TableCell><TableCell>E-posta</TableCell><TableCell>Rol</TableCell><TableCell>Yetki Alanı</TableCell></TableRow></TableHead><TableBody>{team.map((user) => <TableRow key={user.id}><TableCell>{user.name}</TableCell><TableCell>{user.email}</TableCell><TableCell><Chip size="small" label={user.role} /></TableCell><TableCell>{geographicAccessLabel(user)}</TableCell></TableRow>)}</TableBody></Table>}
    </TableContainer>
  </Stack>;
};

export default TeamSection;
